import { Flex } from "@chakra-ui/react";
import { useSlideInMenu } from "../hooks/useSlideInMenu";
import { SlideInHeader } from "../components/SlideInHeader";
import { SLIDE_IN_MENUS } from "../../../screens/root/constants";
import { ComicDetailsContent } from "./ComicDetailsContent";

interface ComicDetailsProps {
  onCloseMenu?: () => void;
}

export function ComicDetails({ onCloseMenu }: ComicDetailsProps) {
  const { comicSlug, navigationContext, goBack, menuInstanceId } =
    useSlideInMenu();

  return (
    <Flex direction="column" height="100%">
      <SlideInHeader
        handleBack={goBack}
        openMenu={SLIDE_IN_MENUS.comicDetails}
        onCloseMenu={onCloseMenu}
      />
      <ComicDetailsContent
        comicSlug={comicSlug ?? ""}
        navigationContext={navigationContext}
        menuInstanceId={menuInstanceId}
      />
    </Flex>
  );
}
